function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}

(function () {

    $('a.show-password').mousedown(function () {
        $(this).parent().find('input').attr('type', 'text');
    }).mouseup(function () {
        $(this).parent().find('input').attr('type', 'password');
    }).mouseout(function () {
        $(this).parent().find('input').attr('type', 'password');
    });

    var $j1FirstBlock = $('.j1-register-form-first-block');
    if ($j1FirstBlock.length === 1) {
        var $email = $('input[type="email"]'),
            $termsFirst = $('.terms-first input', $j1FirstBlock),
            $btn = $('.orange-btn', $j1FirstBlock)
        ;
        $btn.click(function () {
            var error = false;
            if (!isEmail($email.val())) {
                error = true;
                $email.css({"border-color": 'red'}).focus();
            } else {
                $email.removeAttr('style');
            }
            if (!$termsFirst.is(':checked')) {
                error = true;
                $('.terms-first label', $j1FirstBlock).addClass('error');
            } else {
                $('.terms-first label', $j1FirstBlock).removeClass('error');
            }
            if (error !== true) {
                $j1FirstBlock.addClass('d-none');
                $('.j1-register-form').removeClass('d-none');
                $('#email').val($email.val());
            }
        });
    }


})($);